


import { toast } from 'react-toastify'
import { apiConstants } from '../apiConstant'
import compileErrors from '../compileErorrs'
import {  formDataCommonFunctionWithParamsAndBody } from '../serviceCall'
import { setLoading } from '../../feature/authSlice'

export const uploadPropertyApi = (data,params, callback, errorCallBack) => {

  return async (dispatch) => {
    dispatch(setLoading(true))
    formDataCommonFunctionWithParamsAndBody(data, apiConstants.Property.UPLOAD_PROPERTY,params)
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        toast.error(compileErrors(error.response.data.error))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
